// extracted by mini-css-extract-plugin
export default {"CenterDialog":"soMx1Xy_","speechBox":"lCFkdIKC","speaker":"OjNEK4M3","imgBox":"_CXLD40G","speakerImg":"PADMShe3"};
    if(module.hot) {
      // 1738090065239
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  